import { useState } from 'react';

import { Ettermek } from '../reszek/Ettermek.tsx';
import type { Szuro } from '../api.ts';
import { Cegek } from '../reszek/Cegek.tsx';
import { TechnikaiPartnerek } from '../reszek/TechnikaiPartnerek.tsx';
import { AlfulValto } from '../reszek/AlfulValto.tsx';

/**
 * Partnerek. (Megbízás 2.0 / 5.8)
 *
 * Az 1.0-ban ez volt a „Törzsadatok" képernyő az Éttermek füllel. A 2.0-ban
 * a törzs öt önálló menüpontra bomlott, és ide kerül a **Cégek** alfül is —
 * az a 3. blokkban készül el.
 */
type Ful = 'etterem' | 'ceg' | 'technikai';

export function Partnerek({
  onKarton,
  kezdoSzuro,
  kezdoKereses,
}: {
  onKarton: (etterem_id: number) => void;
  kezdoSzuro?: string;
  kezdoKereses?: string;
}) {
  const [ful, setFul] = useState<Ful>('etterem');

  const valto = (
    <AlfulValto<Ful>
      ertek={ful}
      onValt={setFul}
      fulek={[
        { kulcs: 'etterem', cimke: 'Éttermek' },
        { kulcs: 'ceg', cimke: 'Cégek' },
        { kulcs: 'technikai', cimke: 'Átvevők és fuvarozók' },
      ]}
    />
  );

  if (ful === 'ceg') return <Cegek fejlec={valto} />;
  if (ful === 'technikai') return <TechnikaiPartnerek fejlec={valto} />;
  return (
    <Ettermek
      fejlec={valto}
      onKarton={onKarton}
      kezdoSzuro={kezdoSzuro as Szuro | undefined}
      kezdoKereses={kezdoKereses}
    />
  );
}
